import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Button, Col, Row } from "react-bootstrap";
import { loader } from "../../../../../loader";
import { getData, postData } from "../../../../../axios/apiHelper";
import { useSidebar } from "../../../../CommonComponent/LoginLayout";
import { useNavigate } from "react-router-dom";
import { ENDPOINT } from "../../../../../axios/apiConfig";

const AnalyticsEvent = () => {
  const path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;
  const { selectedItem, eventIdContext, handleEventId } = useSidebar();
  let navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [eventListData, setEventListData] = useState([]);
  const [eventListDataOriginal, setEventListDataOriginal] = useState([]);
  const [apiStatus, setApiStatus] = useState(false);
  const [refreshFlag, setRefreshFlag] = useState(false);

  const lastUpdated = useMemo(() => {
    const now = new Date();

    const formatter = new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "UTC",
    });

    // Format parts into an object for custom string building
    const parts = formatter.formatToParts(now);
    const d = parts.find((p) => p.type === "day").value;
    const m = parts.find((p) => p.type === "month").value;
    const y = parts.find((p) => p.type === "year").value;
    const hr = parts.find((p) => p.type === "hour").value;
    const min = parts.find((p) => p.type === "minute").value;
    const dayPeriod = parts
      .find((p) => p.type === "dayPeriod")
      .value.toUpperCase();

    return `${d}-${m}-${y} | ${hr}:${min} ${dayPeriod} UTC`;
  }, [refreshFlag]);

  const fetchAnalyticsData = useCallback(async () => {
    try {
      setRefreshFlag(true);
      loader("show");
      // const body = { eventId };
      const response = await postData("/webinarEmail/get-analytics-event", {});
      const result = response?.data?.data;
      setEventListData(result);
      setEventListDataOriginal(result);

      loader("hide");
    } catch (error) {
      loader("hide");
      console.error("Error fetching analytics data:", error);
    } finally {
      setApiStatus(true);
      setRefreshFlag(false);
    }
  }, []);

  useEffect(() => {
    fetchAnalyticsData();
  }, []);

  const searchChange = (e) => {
    setSearch(e?.target?.value);

    if (e?.target?.value === "") {
      setEventListData(eventListDataOriginal);
    }
  };

  const submitSearchHandler = (event) => {
    event.preventDefault();
    let searchData = eventListDataOriginal?.filter(
      (item) => item?.title?.toLowerCase().includes(search.toLowerCase()),
      // ||
      //   item?.email?.toLowerCase().includes(search.toLowerCase()) ||
      //   item?.country?.toLowerCase().includes(search.toLowerCase()) ||
      //   item?.region?.toLowerCase().includes(search.toLowerCase())
    );

    setEventListData(searchData);
  };

  const surveyQuestionFormDetail = async (e, item) => {
    loader("show");
    const data = await getData(
      ENDPOINT.WEBINAR_GET_EVENT_LISTING + "?page=1&" + "item=" + item?.id,
    );
    const event = data?.data?.data?.data[0];
    const eventDetails = {
      eventId: event?.id,
      companyId: event?.user_id,
      eventCode: event?.event_code,
      eventTitle: event?.title,
      eventStatus: event?.eventStatus,
      isOneSourceEvent: event?.is_onesource_event,
      meetingId: event?.meeting_id,
      meetingPass: event?.meeting_pass,
      streamType: event?.stream_type,
      meetingType: event?.meeting_type,
      preSectionInclude: event?.pre_section_include?.split("~"),
      sectionInclude: event?.section_include?.split("~"),
      postSectionInclude: event?.post_section_include?.split("~"),
      allSections: event?.combined_sections?.split("~"),
      eventStartDateTime: event?.eventStartDateTime,
      eventEndDateTime: event?.eventEndtDateTime,
      streaming_features: event?.streaming_features,
    };
    handleEventId(eventDetails);
    localStorage.setItem("EventIdContext", JSON.stringify(eventDetails));
    navigate("/webinar/analytics", {
      state: { event_id: item?.id, companyId: item?.user_id },
    });
  };

  return (
    <>
      <Col className="right-sidebar">
        <div className="custom-container">
          <Row>
            <div className="top-header">
              <div className="page-title d-flex align-items-center" >
                <h2>Events</h2>
                <div className="d-flex">
                  <p
                    className="d-flex align-items-center"
                    style={{ gap: "10px", paddingLeft: "20px" }}
                  >
                    <button
                      className={refreshFlag ? "refresh-rotate" : "refresh"}
                      title="Refresh"
                      onClick={fetchAnalyticsData}
                    >
                      <svg
                        fill="#0066be"
                        height="20px"
                        width="20px"
                        version="1.1"
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 383.748 383.748"
                      >
                        <g>
                          <path
                            d="M62.772,95.042C90.904,54.899,137.496,30,187.343,30c83.743,0,151.874,68.13,151.874,151.874h30
                                            C369.217,81.588,287.629,0,187.343,0c-35.038,0-69.061,9.989-98.391,28.888C70.368,40.862,54.245,56.032,41.221,73.593
                                            L2.081,34.641v113.365h113.91L62.772,95.042z"
                          ></path>
                          <path
                            d="M381.667,235.742h-113.91l53.219,52.965c-28.132,40.142-74.724,65.042-124.571,65.042
                                            c-83.744,0-151.874-68.13-151.874-151.874h-30c0,100.286,81.588,181.874,181.874,181.874c35.038,0,69.062-9.989,98.391-28.888
                                            c18.584-11.975,34.707-27.145,47.731-44.706l39.139,38.952V235.742z"
                          ></path>
                        </g>
                      </svg>
                    </button>
                    last_sync : {lastUpdated}
                  </p>
                </div>
              </div>
              <div className="top-right-action">
                <div className="search-bar">
                  <form
                    className="d-flex"
                    onSubmit={(e) => submitSearchHandler(e)}
                  >
                    <input
                      className="form-control me-2"
                      type="search"
                      placeholder="Search"
                      aria-label="Search"
                      id="email_search"
                      onChange={(e) => searchChange(e)}
                    />
                    <button className="btn btn-outline" type="submit">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.8045 14.862L11.2545 10.312C12.1359 9.22334 12.6665 7.84 12.6665 6.33334C12.6665 2.84134 9.82522 0 6.33325 0C2.84128 0 0 2.84131 0 6.33331C0 9.82531 2.84132 12.6667 6.33328 12.6667C7.83992 12.6667 9.22325 12.136 10.3119 11.2547L14.8619 15.8047C14.9919 15.9347 15.1625 16 15.3332 16C15.5039 16 15.6745 15.9347 15.8045 15.8047C16.0652 15.544 16.0652 15.1227 15.8045 14.862ZM6.33328 11.3333C3.57597 11.3333 1.33333 9.09066 1.33333 6.33331C1.33333 3.57597 3.57597 1.33331 6.33328 1.33331C9.0906 1.33331 11.3332 3.57597 11.3332 6.33331C11.3332 9.09066 9.09057 11.3333 6.33328 11.3333Z"
                          fill="#97B6CF"
                        />
                      </svg>
                    </button>
                  </form>
                </div>
              </div>
            </div>
            <div className="analytics-events">
              <div className="analytics-events-box">
                {eventListData?.map((event, idx) => (
                  <div
                    key={idx}
                    className="analytics-events-inset d-flex flex-column w-100"
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <h5>{event?.title}</h5>
                      <div className="d-flex align-items-center event-date">
                        <p>{event?.formattedEventStartDateTime}</p>
                        <Button
                          className="shortcut_btn"
                          onClick={(e) => surveyQuestionFormDetail(e, event)}
                        >
                          <img src={path_image + "shortcut-btn.svg"} alt="" />
                        </Button>
                      </div>
                    </div>
                    <div className="d-flex align-items-end flex-wrap analytics-outer-box w-100">
                      <div className="analytics-events-boxes">
                        <p>Registration</p>
                        <div className="d-flex events-boxes-shadow registration-list">
                          <div className="box">
                            <p>Total registered HCPs</p>
                            <div class="email_stats_list d-flex">
                              <div class="d-flex align-items-center">
                                <img
                                  src={path_image + "registered-hcp.svg"}
                                  alt="Export"
                                />
                                <p>
                                  {event?.registration?.totalRegistration || 0}{" "}
                                  <span>
                                    Reached by email |{" "}
                                    <b>
                                      {event?.registration?.reachedByEmail || 0}
                                    </b>
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="box">
                            <p>By Email</p>
                            <div class="email_stats_list d-flex">
                              <div class="d-flex align-items-center">
                                <img
                                  src={path_image + "by-mail.svg"}
                                  alt="Export"
                                />
                                <p>{event?.registration?.byEmailCount || 0}</p>
                              </div>
                            </div>
                          </div>
                          <div className="box">
                            <p>By other channel</p>
                            <div class="email_stats_list d-flex">
                              <div class="d-flex align-items-center">
                                <img
                                  src={path_image + "by-channel.svg"}
                                  alt="Export"
                                />
                                <p>
                                  {event?.registration?.byOtherChannel || 0}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="analytics-events-boxes">
                        <p>Live Stream</p>
                        <div className="d-flex events-boxes-shadow live-streaming-box">
                          <div className="box">
                            <p>Attendees</p>
                            <div class="email_stats_list d-flex">
                              <div class="d-flex align-items-center">
                                <img
                                  src={path_image + "attendees.svg"}
                                  alt="Export"
                                />
                                <p>
                                  {event?.liveStream?.totalUsers || 0} (
                                  {(
                                    (event?.liveStream?.totalUsers /
                                      (event?.registration?.totalRegistration ||
                                        1)) *
                                    100
                                  ).toFixed(2)}
                                  %)
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="box">
                            <p>AVG HCPs online</p>
                            <div class="email_stats_list d-flex">
                              <div class="d-flex align-items-center">
                                <img
                                  src={path_image + "avg-hcp.svg"}
                                  alt="Export"
                                />
                                <p>
                                  {event?.liveStream?.averageHcpsOnline || 0}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="box">
                            <p>AVG spent time</p>
                            <div class="email_stats_list d-flex">
                              <div class="d-flex align-items-center">
                                <img
                                  src={path_image + "avg-spend.svg"}
                                  alt="Export"
                                />
                                <p>
                                  {event?.liveStream?.averageTime || 0} min{" "}
                                  <span>
                                    Live stream{" "}
                                    <b>
                                      {event?.liveStream?.livesStreamTime || 0}
                                      :00
                                    </b>{" "}
                                    min
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="analytics-events-boxes">
                        <p>Q & Poll</p>
                        <div className="d-flex events-boxes-shadow qa-poll-box">
                          <div className="box">
                            <p>Poll Questions</p>
                            <div class="email_stats_list d-flex">
                              <div class="d-flex align-items-center">
                                <img
                                  src={path_image + "poll-question.svg"}
                                  alt="Export"
                                />
                                <p>{event?.pollQuestion?.pollQuestion || 0}</p>
                              </div>
                            </div>
                          </div>
                          <div className="box">
                            <p>AVG HCPs answered</p>
                            <div class="email_stats_list d-flex">
                              <div class="d-flex align-items-center">
                                <img
                                  src={path_image + "avg-answer.svg"}
                                  alt="Export"
                                />
                                <p>
                                  {event?.pollQuestion?.averageHcpsOnAnswered ||
                                    0}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="box">
                            <p>Questions asked</p>
                            <div class="email_stats_list d-flex">
                              <div class="d-flex align-items-center">
                                <img
                                  src={path_image + "question-asked.svg"}
                                  alt="Export"
                                />
                                <p>{event?.pollQuestion?.questionAsked || 0}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="analytics-events-boxes">
                        <p>&nbsp;</p>
                        <div className="d-flex events-boxes-shadow avg-post">
                          <div className="box">
                            <p>AVG post Survey</p>
                            <div class="email_stats_list d-flex">
                              <div class="d-flex align-items-center">
                                <img
                                  src={path_image + "post-survey.svg"}
                                  alt="Export"
                                />
                                <p>
                                  {event?.surveyData?.overall_rating || 0}{" "}
                                  <img
                                    src={path_image + "survey-star.svg"}
                                    alt="Export"
                                  />
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="analytics-events-boxes">
                        <p>&nbsp;</p>
                        <div className="d-flex events-boxes-shadow post-event-view">
                          <div className="box">
                            <p>Post-event views</p>
                            <div class="email_stats_list d-flex">
                              <div class="d-flex align-items-center">
                                <img
                                  src={path_image + "post-event.svg"}
                                  alt="Export"
                                />
                                <p>{event?.postEventViews}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Row>
        </div>
      </Col>
    </>
  );
};

export default AnalyticsEvent;
